import { j as r } from "../../../_virtual/jsx-runtime.js";
import { cn as t } from "../../../lib/utils.js";
import c from "../SkeletonWrapper/index.js";
const u = ({
  isActive: e,
  disabled: o,
  onToggle: s,
  isLoading: a,
  label: n,
  labelClassName: l,
  ...i
}) => /* @__PURE__ */ r.jsx(c, { isLoading: a, children: /* @__PURE__ */ r.jsxs("div", { className: "flex items-center w-fit", children: [
  n && /* @__PURE__ */ r.jsx("span", { className: t("text-xs text-grey-400 mr-2.5", l), children: n }),
  /* @__PURE__ */ r.jsx(
    "button",
    {
      type: "button",
      className: t(
        "relative focus:outline-none w-8 h-5 rounded-full cursor-pointer transition-bg bg-gray-300 border-none p-0",
        e ? "bg-gray-600" : "",
        o && "opacity-50 cursor-not-allowed"
      ),
      onClick: s,
      role: "switch",
      "aria-checked": e,
      disabled: o,
      ...i,
      children: /* @__PURE__ */ r.jsx(
        "span",
        {
          className: t(
            "absolute top-[2px] left-[2px] w-4 h-4 bg-white rounded-full transition-transform",
            e ? "translate-x-3" : ""
          )
        }
      )
    }
  )
] }) });
export {
  u as default
};
